// CommonJS package: named ESM import fails at runtime; use default interop.
import profanityCleaner from "profanity-cleaner";

const PROFANITY_SCAN_MAX_CHARS = 80_000;

export const MODERATION_REJECT_MESSAGE =
    "Το κείμενο ή το αρχείο δεν μπορεί να αποσταλεί λόγω ακατάλληλου περιεχομένου.";

/** Normalize: lowercase + remove accents + basic leetspeak */
export function normalizeForMatch(s: string): string {
    return s
        .toLowerCase()
        .replace(/[@4]/g, "α")
        .replace(/3/g, "ε")
        .replace(/1/g, "ι")
        .replace(/0/g, "ο")
        .replace(/5/g, "σ")
        .replace(/\$/g, "σ")
        .normalize("NFD")
        .replace(/\p{M}/gu, "");
}

const BLOCKED_PHRASES_NORMALIZED: string[] = [
    "child porn",
    "childporn",
    "rape video",
    "snuff film",
    "kill yourself",
    "pornhub",
    "xvideos",
    "onlyfans",
    "xxx video",
    "παιδοφιλ",
    "βιασμος",
    "σεξ βιντεο",
    "πορνο",
    "γαμα την μανα",
    "γαμω την μανα",
    "γαμησε την μανα",
    "αρχιδια σου",
    "αρχιδια σας",
];

const BLOCKED_SUBSTRINGS_GREEK_VULGAR: string[] = [
    "γαμα",
    "γαμη",
    "γαμι",
    "γαμιο",
    "γαμιολ",
    "πουταν",
    "μαλακ",
    "σκυλ",
    "πουστ",
    "καριολ",
    "κωλο",
    "κωλοτρυπ",
    "τσιφου",
];

const BLOCKED_TOKENS_NORMALIZED = new Set<string>([
    "μαλακας",
    "μαλακες",
    "μαλακια",
    "πουτανα",
    "πουτανες",
    "πουστης",
    "πουστηδες",
    "σκυλα",
    "σκυλες",
    "καριολης",
    "καριοληδες",
    "γαμω",
    "γαμησε",
    "γαμωτο",
    "αρχιδια",
    "fuck",
    "fucking",
    "shit",
    "shithead",
    "cunt",
    "nigger",
    "nigga",
    "retard",
    "slut",
    "whore",
    "bitch",
    "asshole",
    "dickhead",
]);

function containsBlockedKeywordContent(text: string): boolean {
    const n = normalizeForMatch(text);
    for (const p of BLOCKED_PHRASES_NORMALIZED) {
        if (n.includes(p)) return true;
    }
    for (const s of BLOCKED_SUBSTRINGS_GREEK_VULGAR) {
        if (n.includes(s)) return true;
    }
    const tokens = n.split(/[^\p{L}\p{N}]+/u).filter(Boolean);
    for (const t of tokens) {
        if (BLOCKED_TOKENS_NORMALIZED.has(t)) return true;
    }
    return false;
}

function profanityCleanerDetects(text: string): boolean {
    const slice =
        text.length > PROFANITY_SCAN_MAX_CHARS
            ? text.slice(0, PROFANITY_SCAN_MAX_CHARS)
            : text;
    try {
        return (
            profanityCleaner.clean(slice, { placeholder: "***" }) !== slice
        );
    } catch {
        return false;
    }
}



export function getModerationSyncError(text: string): string | null {
    const trimmed = text.trim();
    if (!trimmed) return null;
    if (containsBlockedKeywordContent(trimmed)) {
        return MODERATION_REJECT_MESSAGE;
    }
    if (profanityCleanerDetects(trimmed)) {
        return MODERATION_REJECT_MESSAGE;
    }
    return null;
}
